import { render, staticRenderFns } from "./introduction.vue?vue&type=template&id=7facf9ff"
import script from "./introduction.vue?vue&type=script&lang=js"
export * from "./introduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7facf9ff')) {
      api.createRecord('7facf9ff', component.options)
    } else {
      api.reload('7facf9ff', component.options)
    }
    module.hot.accept("./introduction.vue?vue&type=template&id=7facf9ff", function () {
      api.rerender('7facf9ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/help/views/introduction.vue"
export default component.exports